module.exports = __webpack_public_path__ + "static/metaimage-0cee2833c4b46e91982bc25b54878d7c.png";